export const eventQuery = `
  id
  type
  externalUrl
  externalLabel
  name
  description
  descriptionHTML
  image {
    id
    url
  }
  startAt
  endAt
  status
  participantStatus
  participantsCapacity
  participantsRegistrationDeadlineEndAt
  showParticipants
  allowWaitlist
  organisationTags {
    id
    name
  }
  participantCountConfirmed: participantsCount(filters: { participantStatuses: [CONFIRMED] })
  participantCountHost: participantsCount(filters: { participantStatuses: [HOST] })
  participantCountWaitlisted: participantsCount(filters: { participantStatuses: [WAITLISTED] })
  participantsPreview {
    id
    screenName
    avatar {
      url
    }
  }
  location {
    type
    address
    virtualUrl
  }
  permissions {
    allowToDelete
    allowToEdit
    allowToSeeParticipants
    allowToEditChannels
    allowToSeeWaitlisted
    allowToSeeChangeLog
  }
  reminderHoursBeforeStart
  scheduledAt
  channels {
    id
    name
  }
`;
